function sortUpcomingEventsByTimestamp() {
  document.querySelectorAll('.limo-events-centered__grid').forEach((grid) => {
    const items = Array.from(grid.querySelectorAll('.limo-events-centered__item[data-event-ts]'));
    if (items.length === 0) return;
    if (items.some((item) => item.hasAttribute('data-past-event-item'))) return;

    items
      .sort((a, b) => {
        const aTs = Number(a.getAttribute('data-event-ts')) || 0;
        const bTs = Number(b.getAttribute('data-event-ts')) || 0;
        return bTs - aTs;
      })
      .forEach((item) => grid.appendChild(item));
  });
}

function updateLimoEventCountdowns() {
  const nodes = document.querySelectorAll('[data-countdown-target]');
  const nowSeconds = Math.floor(Date.now() / 1000);

  nodes.forEach((node) => {
    const targetSeconds = Number(node.getAttribute('data-countdown-target'));
    if (!targetSeconds) return;

    let diff = targetSeconds - nowSeconds;
    if (diff < 0) diff = 0;

    const days = Math.floor(diff / 86400);
    diff -= days * 86400;
    const hours = Math.floor(diff / 3600);
    diff -= hours * 3600;
    const minutes = Math.floor(diff / 60);
    const seconds = diff - minutes * 60;

    node.textContent =
      days +
      ' Days  :  ' +
      hours +
      ' Hours  :  ' +
      minutes +
      ' Minutes  :  ' +
      seconds +
      ' Seconds';
  });
}

function setupLimoUpcomingCenteredFadeIn(scope = document) {
  const sections = scope.querySelectorAll
    ? scope.querySelectorAll('.limo-events-centered:not([data-limo-past-events-section])')
    : [];

  sections.forEach((section) => {
    if (section.dataset.fadeReady === 'true') return;
    section.dataset.fadeReady = 'true';
    section.classList.add('is-animating');

    const heading = section.querySelector('.limo-events-centered__heading');
    const items = Array.from(section.querySelectorAll('.limo-events-centered__item'));
    const targets = [];
    if (heading) targets.push(heading);
    targets.push(...items);
    if (targets.length === 0) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      typeof IntersectionObserver !== 'function'
    ) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    targets.forEach((target) => {
      if (target.classList.contains('is-visible')) return;
      observer.observe(target);
    });
  });
}

sortUpcomingEventsByTimestamp();
updateLimoEventCountdowns();
setupLimoUpcomingCenteredFadeIn();
window.setInterval(updateLimoEventCountdowns, 1000);

document.addEventListener('shopify:section:load', (event) => {
  setupLimoUpcomingCenteredFadeIn(event.target || document);
});

